import { useParams, useToast } from "duck";
import {
  GetOrganizationAdminUserDocument,
  useUpdateOrganizationAdminMutation
} from "requests";
import { FormValues } from "./types";

export const useUpdateOrganizationAdmin = (adminId?: number) => {
  const [update] = useUpdateOrganizationAdminMutation({ ignoreResults: true });
  const toast = useToast({
    status: "success",
    description: "Organization Admin is updated successfully."
  });
  const { id: orgId } = useParams();

  return (formValues: FormValues) => {
    if (!adminId) {
      return;
    }

    return update({
      variables: {
        input: {
          _id: adminId,
          firstName: formValues.firstName,
          lastName: formValues.lastName,
          email: formValues.email,
          image:
            typeof formValues.image === "number"
              ? { _id: formValues.image }
              : formValues.image
        }
      },
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: GetOrganizationAdminUserDocument,
          variables: { organization: +orgId }
        }
      ]
    }).then(() => {
      toast();
    });
  };
};
